import { existsFilter } from '@iotv/core-services';
import { EntityRollingProgramme, getCurrentAndNextScheduledInfo, isEntityRollingProgrammeConstructorProps, rollingScheduleGenerator, } from '@iotv/datamodel-core';
import { isNonNaNNumber, isValidBusinessObject } from '@iotv/iotv-v3-types';
import { EntityRollingScheduler } from '@iotv/lfc-devices';
import dayjs from 'dayjs';
import { createContext } from 'react';
import { getColorCodeForWindowIndex } from '../Components/Tabs/WindowAllocation/colorCodes';
import { rollingSchedulerDAO } from '../data/dataAccessObject';
const debug = process.env.REACT_APP_DEBUG && false;
export const defaultEntityRollingProgrammeReducerState = {
    rollingProgramme: null,
    scheduler: null,
    schedulerHash: null,
    dataTableRows: null,
    windowData: null,
    fromDateValue: dayjs().startOf('d'),
    toDateValue: dayjs().startOf('d').add(1, 'd'),
};
const isRollingProgrammeReducerSetRollingProgrammeAction = (x) => {
    const c = x;
    return !!c && c.type === 'SetRollingProgramme' && isValidBusinessObject(c.value.rollingProgramme);
};
const isRollingProgrammeReducerMutateRollingProgrammeAction = (x) => {
    const c = x;
    return !!c && c.type === 'MutateRollingProgramme' && isEntityRollingProgrammeConstructorProps(c.value.update);
};
const isRollingProgrammeReducerRecalculateAction = (x) => {
    const c = x;
    return !!c && c.type === 'Recalculate' && c.value === null;
};
const isRollingProgrammeReducerLinkItemsToWindowsAction = (x) => {
    const c = x;
    return !!c && c.type === 'LinkItemsToWindow' && c.value.items.every(isValidBusinessObject) && isNonNaNNumber(c.value.windowProxy.windowIdx);
};
const isRollingProgrammeReducerUnLinkItemsFromWindowsAction = (x) => {
    const c = x;
    return !!c && c.type === 'UnlinkItemsFromWindow' && c.value.items.every(isValidBusinessObject);
};
const isRollingProgrammeReducerFlushWindowsAction = (x) => {
    const c = x;
    return !!c && c.type === 'FlushWindows' && c.value?.windowProxies instanceof Array && c.value.windowProxies.every((x) => isNonNaNNumber(x.windowIdx));
};
const isRollingProgrammeReducerRemoveWindowsAction = (x) => {
    const c = x;
    return !!c && c.type === 'RemoveWindow' && isNonNaNNumber(c.value.windowProxy?.windowIdx);
};
const isRollingProgrammeReducerInsertWindowAboveAction = (x) => {
    const c = x;
    return !!c && c.type === 'InsertWindowAbove' && isNonNaNNumber(c.value.windowProxy?.windowIdx);
};
const isRollingProgrammeReducerInsertWindowBelowAction = (x) => {
    const c = x;
    return !!c && c.type === 'InsertWindowBelow' && isNonNaNNumber(c.value.windowProxy?.windowIdx);
};
const isSetDatesAction = (x) => {
    const c = x ?? {};
    return c.type === 'SetDates' && !!c.value?.fromDateValue && !!c.value?.toDateValue;
};
const isResetAction = (x) => {
    const c = x ?? {};
    return c.type === 'Reset' && !!c.value?.scheduler && c.value.scheduler instanceof EntityRollingScheduler;
};
export const getEntityRollingProgrammeReducer = () => (prev, action) => {
    debug && console.log(`EntityRollingProgrammeReducer got action`, action);
    const update = { ...prev };
    if (isRollingProgrammeReducerSetRollingProgrammeAction(action)) {
        const { value: { rollingProgramme }, } = action;
        update.rollingProgramme = rollingProgramme;
        const schedulerNotPresent = !update.scheduler;
        /** THIS IS UNDER REFACTOR - CURRENTLY TREATING ALL SET ACTIONS HERE AS NEW CONTEXT IS WORKING
         * This is to ensure that the reducer knows the exact context that the AWS Logic has. eg without, it cannon know lastPersistedState
         */
        const schedulerRollingProgrammeChanged = update.scheduler?.rollingProgramme.sk !== update.rollingProgramme.sk;
        /** if scheduler not present OR the scheduler has a different rolling programme, replace the scheduler */
        if (schedulerNotPresent || schedulerRollingProgrammeChanged) {
            const scheduler = new EntityRollingScheduler({ dataAccess: rollingSchedulerDAO, rollingProgramme });
            update.scheduler = scheduler;
            (update.dataTableRows = []),
                (update.windowData = []),
                debug && console.log('INFO EntityRollingProgrammeReducer reset context on', { schedulerNotPresent, schedulerRollingProgrammeChanged });
        }
        else if (update.scheduler) {
            /* TENTATIVE - setting rolling programme should *always* update the scheduler reduce */
            // update.scheduler.rollingProgramme = rollingProgramme
            /* NOW SAME AS ABOVE PENDING TESTING */
            const scheduler = new EntityRollingScheduler({ dataAccess: rollingSchedulerDAO, rollingProgramme });
            update.scheduler = scheduler;
            (update.dataTableRows = []),
                (update.windowData = []),
                debug && console.log('INFO EntityRollingProgrammeReducer reset context on', { schedulerNotPresent, schedulerRollingProgrammeChanged });
        }
        Object.assign(update, recalculate(update));
    }
    else if (isRollingProgrammeReducerMutateRollingProgrammeAction(action)) {
        update.rollingProgramme = new EntityRollingProgramme(action.value.update);
        if (update.scheduler) {
            // this is the reverse of normal but looks OK as scheduler is updated before recalculate
            update.scheduler.rollingProgramme = update.rollingProgramme;
        }
        Object.assign(update, recalculate(update));
    }
    else if (isRollingProgrammeReducerLinkItemsToWindowsAction(action)) {
        const { windowProxy: { windowIdx }, items, } = action.value;
        if (update.scheduler) {
            items.forEach((item) => update.scheduler?.allocateItemToWindowByIdx(item, windowIdx));
            update.rollingProgramme = update.scheduler.rollingProgramme;
            Object.assign(update, recalculate(update));
        }
    }
    else if (isRollingProgrammeReducerUnLinkItemsFromWindowsAction(action)) {
        const { items } = action.value;
        /* Note this requires items to be selected in Tree and will remove from all Windows */
        if (update.scheduler) {
            items.forEach((item) => update.scheduler?.deAllocateItemFromWindows(item));
            update.rollingProgramme = update.scheduler.rollingProgramme;
            Object.assign(update, recalculate(update));
        }
    }
    else if (isRollingProgrammeReducerFlushWindowsAction(action)) {
        const { windowProxies } = action.value;
        if (update.scheduler) {
            for (let windowProxy of windowProxies) {
                update.scheduler.flushWindow(windowProxy.windowIdx);
            }
            update.rollingProgramme = update.scheduler.rollingProgramme;
            Object.assign(update, recalculate(update));
        }
    }
    else if (isRollingProgrammeReducerRemoveWindowsAction(action)) {
        const { windowProxy } = action.value;
        if (update.scheduler) {
            update.scheduler.removeWindow(windowProxy.windowIdx);
            update.rollingProgramme = update.scheduler.rollingProgramme;
            Object.assign(update, recalculate(update));
        }
    }
    else if (isRollingProgrammeReducerInsertWindowAboveAction(action)) {
        const { windowProxy } = action.value;
        if (update.scheduler) {
            update.scheduler.loadNewWindow(windowProxy.windowIdx - 1);
            update.rollingProgramme = update.scheduler.rollingProgramme;
            Object.assign(update, recalculate(update));
        }
    }
    else if (isRollingProgrammeReducerInsertWindowBelowAction(action)) {
        const { windowProxy } = action.value;
        if (update.scheduler) {
            update.scheduler.loadNewWindow(windowProxy.windowIdx);
            update.rollingProgramme = update.scheduler.rollingProgramme;
            Object.assign(update, recalculate(update));
        }
    }
    else if (isRollingProgrammeReducerRecalculateAction(action)) {
        Object.assign(update, recalculate(update));
    }
    else if (isSetDatesAction(action)) {
        const { fromDateValue, toDateValue } = action.value;
        update.fromDateValue = fromDateValue;
        update.toDateValue = toDateValue;
        debug && console.log(`EntityProgrammeReducer got SetDatesAction`, action);
        Object.assign(update, recalculate(update));
    }
    else if (isResetAction(action)) {
        const { scheduler } = action.value;
        update.dataTableRows = [];
        update.windowData = [];
        update.rollingProgramme = scheduler.rollingProgramme;
        update.scheduler = scheduler;
        update.schedulerHash = scheduler.context.getHash();
        Object.assign(update, recalculate(update));
    }
    else {
        console.log(`WARN: action fell through reducer`, action);
    }
    update.schedulerHash = update.scheduler?.context.getHash() ?? null;
    return update;
};
const recalculate = (state) => {
    const { rollingProgramme } = state;
    const update = { ...state };
    const scheduler = update.scheduler;
    if (rollingProgramme && scheduler) {
        const relativeDate = new Date(); // replace with relative date in state
        const startWindowDataRow = Array.from({ length: rollingProgramme.windows ?? 0 }, (v, windowIdx) => windowIdx)
            .map(rollingProgramme.getRollingProgrammeConfigForWindowIdx)
            .map((rollingPatternConfig, windowIdx) => {
            const { delay, duration, startTimeUtcSeconds } = rollingPatternConfig ?? {};
            if (rollingPatternConfig) {
                const validSchduleOutput = getCurrentAndNextScheduledInfo({ relativeDate, rollingPatternConfig });
                if (validSchduleOutput) {
                    const { nextScheduledStartMs } = validSchduleOutput;
                    if (delay && duration && startTimeUtcSeconds) {
                        const startWindowData = {
                            id: windowIdx.toString(),
                            delayMins: delay,
                            durationMins: duration,
                            startTimeUtcSeconds,
                            nextScheduledStartMs,
                            windowIdx,
                            entities: scheduler?.getItemsForWindow(windowIdx) ?? [],
                        };
                        return startWindowData;
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        })
            .filter(existsFilter);
        const { fromDateValue, toDateValue } = state;
        if (fromDateValue && toDateValue) {
            update.dataTableRows = scheduleToDataTableRows({ rollingProgramme, scheduler, fromDateValue, toDateValue });
        }
        update.rollingProgramme = rollingProgramme;
        update.windowData = startWindowDataRow;
        console.log(`EntityRollingProgrammeReducer has windows`, update.windowData);
    }
    return update;
};
const scheduleToDataTableRows = ({ rollingProgramme, scheduler, fromDateValue, toDateValue }) => {
    const rollingProgrammeConfigs = Array.from({ length: rollingProgramme.windows ?? 0 }, (v, i) => i).map(rollingProgramme.getRollingProgrammeConfigForWindowIdx);
    const schedules = rollingProgrammeConfigs.map((rollingPatternConfig) => {
        if (rollingPatternConfig) {
            const p = { startDate: fromDateValue?.toDate(), endDate: toDateValue?.toDate(), rollingPatternConfig };
            const genratorX = rollingScheduleGenerator(p);
            return Array.from(genratorX);
        }
    });
    const dataTableRows = schedules
        .map((drs, windowIdx) => {
        const dateRanges = drs ?? [];
        const dtrs = dateRanges.map(([fromDate, toDate]) => {
            const scheduledItemNames = scheduler.getItemsForWindow(windowIdx)?.map((i) => i.name);
            return {
                rowHeader: 'Windows',
                itemName: scheduledItemNames?.length ? scheduledItemNames.join(', ') : '(No items)',
                style: getColorCodeForWindowIndex(windowIdx),
                fromDate,
                toDate,
            };
        });
        const arrays = dtrs.map((dtr) => Object.values(dtr));
        return arrays;
    })
        .flat();
    return dataTableRows;
};
export const EntityRollingProgrammeContext = createContext([
    defaultEntityRollingProgrammeReducerState,
    (next) => {
        throw new Error('Reducer not initialized');
    },
]);
